/**
 * If a loader throws this, a redirect to the given location is performed.
 * @see RedirectLimitError
 */
export class RedirectError extends Error {
    location;
    constructor(location) {
        super('redirect');
        this.location = location;
    }
}
/**
 * If the redirect limit is reached, no further redirects are attempted and this error is thrown instead.
 * @see RedirectError
 * @see Options#redirectLimit
 */
export class RedirectLimitError extends Error {
    constructor() {
        super('redirect limit reached');
    }
}
